import { render, staticRenderFns } from "./user-operators-mapping.vue?vue&type=template&id=1dfb7458&scoped=true&"
import script from "./user-operators-mapping.vue?vue&type=script&lang=tsx&"
export * from "./user-operators-mapping.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb7458",
  null
  
)

export default component.exports